import { inject } from 'vue'
import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core'

export function useClient() {
  const apolloClient =
    inject<ApolloClient<NormalizedCacheObject>>('apolloClient')
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return apolloClient!
}
